import { render, staticRenderFns } from "./TooltipInformativo.vue?vue&type=template&id=57c46f10&scoped=true&"
import script from "./TooltipInformativo.vue?vue&type=script&lang=js&"
export * from "./TooltipInformativo.vue?vue&type=script&lang=js&"
import style0 from "./TooltipInformativo.vue?vue&type=style&index=0&id=57c46f10&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c46f10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})
